// ─────────────────────────────────────────────────────────────
//  LanguageSwitcher.js
//
//  3 yerde kullanılır:
//    1) SideMenu alt kısmı        → variant="sidemenu"
//    2) AuthPage                  → variant="auth"
//    3) AyarlarPanel Genel sekmesi → variant="settings" (default)
//
//  Firebase sync dışarıdan opsiyonel olarak verilir:
//    <LanguageSwitcher onChangeLang={firebaseUpdateFn} />
// ─────────────────────────────────────────────────────────────

import React from "react";
import { useLanguage, LANGUAGES, LANGUAGE_LABELS } from "../i18n/LanguageContext";

export default function LanguageSwitcher({ variant = "settings", onChangeLang }) {
  const { lang, setLang, t } = useLanguage();
  const isLightTheme = document.documentElement.classList.contains("light");


  const handleChange = (newLang) => {
    if (newLang === lang) return;
    setLang(newLang);
    if (typeof onChangeLang === "function") {
      onChangeLang(newLang);
    }
  };

  /* ── Settings / AyarlarPanel varyantı ── */
  if (variant === "settings") {
    return (
      <div className="ayarGrup">
        <div className="ayarGrupBaslik">{t("settings.language")}</div>
        <div className="ayarToggleRow">
          {LANGUAGES.map((l) => (
            <button
              key={l}
              className={lang === l ? "ayarToggleBtn active" : "ayarToggleBtn"}
              onClick={() => handleChange(l)}
            >
              {LANGUAGE_LABELS[l]}
            </button>
          ))}
        </div>
      </div>
    );
  }

  /* ── SideMenu alt kısım varyantı ── */
  if (variant === "sidemenu") {
    return (
      <div className="sideMenuLangSwitcher">
        <span className="sideMenuLangLabel">🌐</span>
        <div className="sideMenuLangBtns">
          {LANGUAGES.map((l) => (
            <button
key={l}
className={lang === l ? "sideMenuLangBtn active" : "sideMenuLangBtn"}
onClick={() => handleChange(l)}
style={
lang !== l
? {
color: "#8592b1",
fontWeight: 600,
background: isLightTheme
? "rgba(255, 255, 255, 0.85)"
: "rgba(255, 255, 255, 0.10)",
border: isLightTheme
? "1px solid rgba(15, 23, 42, 0.18)"
: "1px solid rgba(255, 255, 255, 0.22)",
boxShadow: isLightTheme
? "0 2px 8px rgba(15, 23, 42, 0.08)"
: "0 2px 8px rgba(0, 0, 0, 0.22)",
}
: {}
}


>

{LANGUAGE_LABELS[l]} </button>

          ))}
        </div>
      </div>
    );
  }

  /* ── Auth sayfası varyantı ── */
  if (variant === "auth") {
    return (
      <div className="authLangSwitcher">
        {LANGUAGES.map((l) => (
          <button
            key={l}
            className={lang === l ? "authLangBtn active" : "authLangBtn"}
            onClick={() => handleChange(l)}
          >
            {LANGUAGE_LABELS[l]}
          </button>
        ))}
      </div>
    );
  }

  return null;
}
